import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { titleResolver } from 'wflow-cdk';
import { EmptyComponent } from 'wflow-main-app/src/app/core/components/empty.component';
import { ForbiddenGuard } from './core/guards/forbidden.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { TrialPeriodExpiredGuard } from './core/guards/trial-period-expired.guard';
import { APP_ROUTES } from './routing.const';
import { ExternalLinkResolver } from './shared/services/external-link.resolver';
import { BINARBASE_GUARD_TOKEN } from './pages/binarbase/tokens/binarbase-guard.token';
import { AppBiEnabledGuard } from './core/guards/app-bi-enabled-guard';
import { ContactSupportGuard } from './pages/contact-support/contact-support.guard';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard, TrialPeriodExpiredGuard],
    title: titleResolver('NavOrgList'),
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: APP_ROUTES.DASHBOARD,
    redirectTo: `/`,
    pathMatch: 'full',
  },
  {
    path: APP_ROUTES.BINARBASE,
    title: titleResolver('REPORTING.Reporting'),
    canActivateChild: [AuthGuard, BINARBASE_GUARD_TOKEN],
    loadChildren: () =>
      import('./pages/binarbase/binarbase.module').then(
        (m) => m.BinarbaseModule,
      ),
  },
  {
    title: titleResolver('SignOut'),
    path: APP_ROUTES.LOGOUT,
    loadComponent: () =>
      import('./pages/logout/logout.component').then((m) => m.LogoutComponent),
  },
  {
    path: APP_ROUTES.REGISTRATION,
    loadChildren: () =>
      import('./pages/registration/registration-page.module').then(
        (m) => m.RegistrationPageModule,
      ),
  },
  {
    path: APP_ROUTES.CONTACT_SUPPORT,
    title: titleResolver('NEW_USER.Title'),
    canActivate: [AuthGuard, ContactSupportGuard],
    loadComponent: () =>
      import('./pages/contact-support/contact-support.component').then(
        (m) => m.ContactSupportComponent,
      ),
  },
  {
    path: APP_ROUTES.CUSTOMER,
    title: titleResolver('CUSTOMER_ADMIN.Administration'),
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./pages/customer/customer.module'),
  },
  {
    path: APP_ROUTES.ORGANIZATION,
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./pages/org/org.module').then((m) => m.OrgModule),
  },
  {
    title: titleResolver('VerifyingYourIdentity'),
    path: APP_ROUTES.UNAUTHORIZED,
    loadChildren: () =>
      import('./pages/unauthorized/unauthorized.module').then(
        (m) => m.UnauthorizedModule,
      ),
  },
  {
    title: titleResolver('Forbidden403'),
    path: APP_ROUTES.FORBIDDEN,
    canActivateChild: [ForbiddenGuard],
    loadChildren: () =>
      import('./pages/forbidden/forbidden.module').then(
        (m) => m.ForbiddenModule,
      ),
  },
  {
    title: titleResolver('NotFound404'),
    path: APP_ROUTES.NOTFOUND,
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./pages/notfound/notfound.module').then((m) => m.NotfoundModule),
  },
  {
    path: APP_ROUTES.EXPIRED,
    canActivateChild: [AuthGuard],
    loadChildren: () =>
      import('./pages/trial-period-expired/trial-period-expired.module').then(
        (m) => m.TrialPeriodExpiredModule,
      ),
  },
  {
    title: titleResolver('BasicErrorHandlerService_DefaultErrorTitle'),
    path: APP_ROUTES.MAINTENANCE,
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./pages/maintenance/maintenance.component'),
  },
  {
    path: `${APP_ROUTES.EXTERNAL}/:externalUrl`,
    resolve: {
      url: ExternalLinkResolver,
    },
    component: EmptyComponent,
  },
  {
    path: '**',
    redirectTo: `/${APP_ROUTES.NOTFOUND}`,
    pathMatch: 'full',
  },
];

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
};

@NgModule({
  providers: [
    ExternalLinkResolver,
    { provide: BINARBASE_GUARD_TOKEN, useClass: AppBiEnabledGuard },
  ],
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
